<div class="operator-dashboard" data-testid="operator-dashboard-home">
	<xp-page-header class="dashboard-header" heading="Dashboard">
		<p xpPageHeaderNote class="dashboard-greeting">
			Hello, <strong>{{ greetingName }}</strong>. Here's today's update from Fleet Xpress in Metro Manila.
		</p>
		<div class="dashboard-date-anchor" [class.tour-spotlight]="activeTourStep?.id === 'date-range'">
			<operator-dashboard-date-picker data-testid="operator-dashboard-date-filter"
											[preset]="datePreset"
											[startDate]="filterObj.startDate"
											[endDate]="filterObj.endDate"
											(apply)="onDatePickerApply($event)">
			</operator-dashboard-date-picker>
			<ng-container *ngIf="activeTourStep?.id === 'date-range'"
						  [ngTemplateOutlet]="tourCard"
						  [ngTemplateOutletContext]="{ placement: 'date' }">
			</ng-container>
		</div>
	</xp-page-header>

	<div class="dashboard-grid">
		<div class="dashboard-grid__main">
			<section class="performance-overview"
					 data-testid="operator-dashboard-performance-overview"
					 [class.tour-spotlight]="activeTourStep?.id === 'performance'">
				<h2 class="section-title">Performance Overview</h2>
				<div class="kpi-row">
					<ng-container *ngIf="isStatisticsLoading && !performancePreviewActive">
						<mat-card class="kpi-card" *ngFor="let _ of kpiSkeletonItems">
							<mat-card-content class="state-container">
								<xp-loading [diameter]="36"></xp-loading>
							</mat-card-content>
						</mat-card>
					</ng-container>

					<ng-container *ngIf="showKpiCards">
							<mat-card class="kpi-card"
								  *ngFor="let stats of kpiCards"
								  [class.kpi-card--empty]="isKpiEmpty(stats)"
								  [attr.data-testid]="'operator-dashboard-kpi-' + kpiTestId(stats)">
							<mat-card-content>
								<ng-container *ngIf="!isKpiEmpty(stats)">
									<div class="kpi-card__title-row">
										<div class="kpi-card__title">{{ stats.Header }}</div>
										<div class="kpi-card__value-row">
											<span class="kpi-card__value">{{ stats.HeaderPercentage }}</span>
											<span class="kpi-card__unit">%</span>
										</div>
									</div>
									<div class="kpi-card__body">
										<div class="kpi-card__metrics">
											<xp-badge class="trend trend--up" *ngIf="stats.PercentageIncrease > 0" icon="trending_up">{{ stats.PercentageIncrease }}%</xp-badge>
											<xp-badge class="trend trend--down" *ngIf="stats.PercentageIncrease < 0" icon="trending_down">{{ stats.PercentageIncrease }}%</xp-badge>
											<div class="kpi-card__footer">{{ stats.Footer }}</div>
										</div>
										<div class="kpi-card__chart" *ngIf="hasKpiChart(stats)">
											<xp-chart type="line" [data]="stats | getChartData" [options]="options" height="100px"></xp-chart>
										</div>
									</div>
								</ng-container>

								<div class="kpi-card__empty" *ngIf="isKpiEmpty(stats)">
									<div class="kpi-card__empty-row">
										<div class="kpi-card__title">{{ stats.Header }}</div>
										<span class="kpi-card__empty-sparkline" aria-hidden="true"></span>
									</div>
									<div class="kpi-card__empty-row">
										<span class="kpi-card__empty-rate" aria-hidden="true"></span>
										<span class="kpi-card__empty-status">No activity</span>
									</div>
									<div class="kpi-card__empty-footer">{{ kpiEmptyFooter() }}</div>
								</div>
							</mat-card-content>
						</mat-card>
					</ng-container>

					<ng-container *ngIf="!isStatisticsLoading && statistics && !statistics.Success && !performancePreviewActive">
						<mat-card class="kpi-card" *ngFor="let _ of kpiSkeletonItems">
							<mat-card-content>
								<xp-empty-state class="state-container state-container--warning"
												icon="warning"
												description="Something went wrong"></xp-empty-state>
							</mat-card-content>
						</mat-card>
					</ng-container>
				</div>
				<ng-container *ngIf="activeTourStep?.id === 'performance'"
							  [ngTemplateOutlet]="tourCard"
							  [ngTemplateOutletContext]="{ placement: 'below' }">
				</ng-container>
			</section>

			<section class="booking-history"
					 data-testid="operator-dashboard-booking-history"
					 [class.tour-spotlight]="activeTourStep?.id === 'bookings'">
				<h2 class="section-title">Booking History</h2>
				<mat-card class="long-chart-card">
				<mat-card-content>
					<ng-container *ngIf="isStatisticsLoading && !bookingPreviewActive">
						<div class="state-container state-container--compact">
							<xp-loading [diameter]="36"></xp-loading>
						</div>
					</ng-container>

					<ng-container *ngIf="!isStatisticsLoading || bookingPreviewActive">
						<div class="long-chart-card__summary"
							 *ngIf="showBookingFilled">
							<div class="long-chart-card__item" *ngFor="let chart of bookingSummaryCards">
								<div class="long-chart-card__label">{{ chart.Header }}</div>
								<div class="long-chart-card__count">{{ chart.HeaderPercentage || 0 }}</div>
								<xp-badge class="trend trend--up" *ngIf="chart.PercentageIncrease > 0" icon="trending_up">{{ chart.PercentageIncrease }}%</xp-badge>
								<xp-badge class="trend trend--down" *ngIf="chart.PercentageIncrease < 0" icon="trending_down">{{ chart.PercentageIncrease }}%</xp-badge>
							</div>
						</div>

						<div class="long-chart-card__empty"
							 *ngIf="showBookingEmpty">
							<div class="long-chart-card__summary">
								<div class="long-chart-card__item" *ngFor="let label of bookingHistoryEmptyLabels">
									<div class="long-chart-card__label">{{ label }}</div>
									<div class="long-chart-card__bar" aria-hidden="true"></div>
								</div>
							</div>
							<div class="long-chart-card__empty-body">
								<div class="long-chart-card__empty-icon-wrap">
									<mat-icon class="long-chart-card__empty-icon">show_chart</mat-icon>
								</div>
								<p class="long-chart-card__empty-title">No bookings in this period</p>
								<p class="long-chart-card__empty-copy">Try a different date range, or check back once new requests come in.</p>
								<div class="long-chart-card__legend">
									<span class="long-chart-card__legend-item long-chart-card__legend-item--requests">Total Requests</span>
									<span class="long-chart-card__legend-item long-chart-card__legend-item--completed">Completed Bookings</span>
									<span class="long-chart-card__legend-item long-chart-card__legend-item--active">Active Bookings</span>
								</div>
							</div>
						</div>

						<xp-empty-state class="state-container state-container--compact state-container--warning"
										*ngIf="statistics && !statistics.Success && !bookingPreviewActive"
										icon="warning"
										description="Something went wrong"></xp-empty-state>

						<div class="long-chart-card__chart"
							 *ngIf="showBookingFilled">
							<xp-chart type="bar" [data]="bookingChartData" [options]="requestsOptions"></xp-chart>
						</div>
					</ng-container>
				</mat-card-content>
				</mat-card>
				<ng-container *ngIf="activeTourStep?.id === 'bookings'"
							  [ngTemplateOutlet]="tourCard"
							  [ngTemplateOutletContext]="{ placement: 'above' }">
				</ng-container>
			</section>
		</div>
	</div>

	<!-- Map + Online drivers -->
	<div class="drivers-section">
		<div class="live-operations">
			<div class="live-operations__map" [class.tour-spotlight]="activeTourStep?.id === 'map'">
				<mat-card class="map-card">
					<mat-card-content class="map-card__content">
						<div #operatorMap class="map-container"></div>

						<div class="map-marker-card"
							 *ngIf="selectedMapDriver"
							 role="dialog"
							 aria-label="Driver status">
							<button xpButton variant="icon"
									type="button"
									class="map-marker-card__close"
									(click)="closeMarkerCard()"
									aria-label="Close">
								×
							</button>
							<div class="map-marker-card__name">{{ getDriverDisplayName(selectedMapDriver) }}</div>
							<xp-badge class="map-marker-card__status"
									  [class.map-marker-card__status--on-trip]="isOnTrip(selectedMapDriver.DriverActivityStatus)"
									  [class.map-marker-card__status--idle]="!isOnTrip(selectedMapDriver.DriverActivityStatus)"
									  [icon]="isOnTrip(selectedMapDriver.DriverActivityStatus) ? 'local_taxi' : 'schedule'">{{ getDriverStatusLabel(selectedMapDriver.DriverActivityStatus) }}</xp-badge>
						</div>
					</mat-card-content>
				</mat-card>
				<ng-container *ngIf="activeTourStep?.id === 'map'"
							  [ngTemplateOutlet]="tourCard"
							  [ngTemplateOutletContext]="{ placement: 'above' }">
				</ng-container>
			</div>
		</div>

		<div class="online-drivers" [class.tour-spotlight]="activeTourStep?.id === 'drivers'">
			<mat-card class="drivers-card">
				<mat-card-header>
					<mat-card-title>Online Drivers</mat-card-title>
				</mat-card-header>

				<mat-card-content class="drivers-list">
					<div class="drivers-empty" *ngIf="showOnlineDriversEmpty">
						<div class="drivers-empty__icon-wrap">
							<mat-icon class="drivers-empty__icon">directions_car</mat-icon>
						</div>
						<p class="drivers-empty__title">No drivers online right now</p>
						<p class="drivers-empty__copy">Online drivers will show up here as they go active. Check back shortly.</p>
					</div>

					<xp-empty-state class="state-container state-container--warning"
									*ngIf="isOnlineDriverError && !driversPreviewActive"
									icon="warning"
									description="Something went wrong"></xp-empty-state>

					<xp-loading class="state-container" [diameter]="36" *ngIf="isOnlineDriverLoading && !driversPreviewActive"></xp-loading>

					<mat-card class="driver-item" *ngFor="let driver of displayedOnlineDrivers">
						<mat-card-content>
							<div class="driver-item__header">
								<xp-avatar class="driver-item__avatar"
										   [initials]="getDriverInitials(driver)"
										   [attr.aria-label]="driver.FirstName"></xp-avatar>
								<div class="driver-item__info">
									<div class="driver-item__name">{{ driver.FirstName }} {{ driver.LastName }}</div>
									<div class="driver-item__phone">{{ driver.PhoneNumber }}</div>
								</div>
								<button mat-stroked-button color="primary" class="driver-item__action" (click)="handleViewDriverInfo(driver.DriverId)">
									View Driver Info
								</button>
							</div>

							<div class="driver-item__stats">
								<xp-badge class="status-pill"
										  [class.status-pill--on-trip]="isOnTrip(driver.DriverActivityStatus)"
										  [class.status-pill--idle]="!isOnTrip(driver.DriverActivityStatus)"
										  [iconSrc]="driver.DriverActivityStatus | getIconPercent">{{ getDriverStatusLabel(driver.DriverActivityStatus) }}</xp-badge>
							</div>
						</mat-card-content>
					</mat-card>
				</mat-card-content>
			</mat-card>
			<ng-container *ngIf="activeTourStep?.id === 'drivers'"
						  [ngTemplateOutlet]="tourCard"
						  [ngTemplateOutletContext]="{ placement: 'above' }">
			</ng-container>
		</div>
	</div>

	<div class="tour-backdrop" *ngIf="tourPhase !== 'idle'" data-testid="operator-dashboard-tour-backdrop"></div>

	<section class="tour-welcome"
			 *ngIf="tourPhase === 'welcome'"
			 role="dialog"
			 aria-modal="true"
			 aria-labelledby="operator-dashboard-tour-title"
			 data-testid="operator-dashboard-tour-welcome">
		<img class="tour-welcome__logo"
			 src="/Content/xpress-app/images/xpress-region-logo.svg"
			 alt="Xpress">
		<div class="welcome-scene" aria-hidden="true">
			<div class="welcome-scene__skyline"></div>
			<div class="welcome-scene__map">
				<svg class="welcome-scene__roads" viewBox="0 0 240 170" focusable="false">
					<path d="M8 28 H232 M8 78 H232 M8 128 H232 M48 8 V162 M120 8 V162 M188 8 V162" />
					<path d="M48 28 L120 78 L188 28" />
				</svg>
				<span class="welcome-scene__pin"></span>
			</div>
			<div class="welcome-scene__driver">
				<span class="welcome-scene__avatar">JD</span>
				<span class="welcome-scene__driver-copy">
					<span class="welcome-scene__name">Juan Dela Cruz <span class="welcome-scene__online"></span></span>
					<span class="welcome-scene__phone">+63 912 345 6789</span>
				</span>
			</div>
			<div class="welcome-scene__rating">
				<div class="welcome-scene__score"><strong>4</strong>/5 <span>102 Ratings</span></div>
				<div class="welcome-scene__stars"><span>★</span><span>★</span><span>★</span><span>★</span><span class="is-empty">★</span></div>
			</div>
			<img class="welcome-scene__car welcome-scene__car--back"
				 src="/Content/xpress-app/images/operator/tour/welcome-suv.png"
				 alt="">
			<img class="welcome-scene__car welcome-scene__car--front"
				 src="/Content/xpress-app/images/operator/tour/welcome-sedan.png"
				 alt="">
		</div>
		<h2 id="operator-dashboard-tour-title" class="tour-welcome__title">Welcome to Xpress Operator Portal!</h2>
		<p class="tour-welcome__body">
			We're pleased to have you here! This quick tour will guide you through the key features—managing drivers, tracking invitations, and monitoring your fleet's performance.
		</p>
		<div class="tour-welcome__actions">
			<button type="button"
					class="tour-btn tour-btn--text"
					data-testid="operator-dashboard-tour-explore"
					(click)="exploreOnMyOwn()">
				Explore on my own
			</button>
			<button #tourStartButton
					type="button"
					class="tour-btn tour-btn--primary"
					data-testid="operator-dashboard-tour-start"
					(click)="startTour()">
				Take a quick tour
			</button>
		</div>
	</section>

	<ng-template #tourCard let-placement="placement">
		<div class="tour-popover"
			 *ngIf="activeTourStep as step"
			 role="dialog"
			 [attr.aria-label]="step.title"
			 [ngClass]="'tour-popover--' + placement"
			 data-testid="operator-dashboard-tour-step">
			<p class="tour-popover__step">Step {{ tourStepIndex + 1 }} of {{ tourSteps.length }}</p>
			<h3 class="tour-popover__title">{{ step.title }}</h3>
			<p class="tour-popover__body">{{ step.body }}</p>
			<div class="tour-popover__preview" *ngIf="step.allowsPreview">
				<span>Preview of data when activity is available.</span>
				<button type="button"
						class="tour-popover__preview-toggle"
						data-testid="operator-dashboard-tour-preview"
						[attr.aria-pressed]="tourPreviewFilled"
						(click)="toggleTourPreview()">
					{{ tourPreviewFilled ? 'Hide' : 'Show' }}
				</button>
			</div>
			<div class="tour-popover__actions">
				<button type="button"
						class="tour-btn tour-btn--text"
						data-testid="operator-dashboard-tour-skip"
						(click)="skipTour()">
					Skip tour
				</button>
				<div class="tour-popover__nav">
					<button type="button"
							class="tour-btn tour-btn--ghost"
							*ngIf="tourStepIndex > 0"
							data-testid="operator-dashboard-tour-back"
							(click)="previousTourStep()">
						Back
					</button>
					<button type="button"
							class="tour-btn tour-btn--primary tour-btn--compact"
							data-testid="operator-dashboard-tour-next"
							(click)="nextTourStep()">
						{{ isLastTourStep ? 'Finish' : 'Next' }}
					</button>
				</div>
			</div>
		</div>
	</ng-template>
</div>
